import { createContext, useContext, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchSurveyConfig } from '../actions/SurveyConfigActions';
import { getSurveyConfigSelector } from '../selectors';
import { jsx as _jsx } from "react/jsx-runtime";
const SurveyConfigContext = /*#__PURE__*/createContext({});
export const useSurveyConfig = () => useContext(SurveyConfigContext);
export const SurveyConfigProvider = ({
  children
}) => {
  const dispatch = useDispatch();
  const surveyConfigResponse = useSelector(getSurveyConfigSelector);
  const [isFetched, setIsFetched] = useState(surveyConfigResponse.isFetched || false);
  const [error, setError] = useState(surveyConfigResponse.error || '');
  const [surveyConfig, setSurveyConfig] = useState(surveyConfigResponse);
  useEffect(() => {
    if (surveyConfigResponse) {
      setSurveyConfig(surveyConfigResponse);
      setIsFetched(surveyConfigResponse.isFetched);
      setError(surveyConfigResponse.error);
    }
  }, [surveyConfigResponse]);
  const fetchSurvey = (params, surveyType) => {
    dispatch(fetchSurveyConfig(surveyType, params));
  };
  const updatePreview = config => {
    setSurveyConfig(config);
  };
  return /*#__PURE__*/_jsx(SurveyConfigContext.Provider, {
    value: {
      error,
      fetchSurvey,
      isFetched,
      surveyConfig,
      updatePreview
    },
    children: children
  });
};